module.exports = __webpack_public_path__ + "media/images/testing/expert-rating-logo-e82fe8c4f72a93a72464577463cb5129.gif";